import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  buildDesktopAuthLink,
  markDesktopAuthLaunched,
  readLaunchedDesktopAuth,
} from "../Utils/desktopAuthRelay";
import { usePageTitle } from "../Hooks/usePageTitle";
import "./desktopAuthCompleted.css";

function DesktopAuthCompletedRouteComponent() {
  const { search } = useLocation();
  const [ready, setReady] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [closed, setClosed] = useState(false);
  usePageTitle("Launching OverWatch");

  useEffect(() => {
    const link = buildDesktopAuthLink(search);
    const launched = readLaunchedDesktopAuth();

    if (!link) {
      if (launched) {
        setReady(true);
        setCountdown(0);
        return;
      }
      window.location.replace("https://app.4sightlabs.com");
      return;
    }

    setReady(true);
    if (launched === link.key) return;
    markDesktopAuthLaunched(link.key);
    window.history.replaceState(null, "", window.location.pathname);
    window.location.href = link.href;
  }, [search]);

  // Countdown → auto-close
  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setCountdown((n) => {
        if (n <= 1) {
          clearInterval(interval);
          window.close();
          setClosed(true); // fallback if window.close() is blocked
          return 0;
        }
        return n - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) return null;

  return (
    <main className="dac-screen">
      <img
        src="/svgs/Navbar/4SightLabs Logo.svg"
        alt="OverWatch"
        className="dac-top-logo"
      />
      <div className="dac-center">
        <div className="dac-icon-wrap">
          <img
            src="/svgs/4SightLabs_Mini_Logo.svg"
            alt=""
            className="dac-icon"
          />
        </div>
        <h1 className="dac-headline">Launching OverWatch</h1>
        <p className="dac-instruction">
          Click <strong>"Open OverWatch"</strong> to launch the desktop app.
        </p>
        {countdown > 0 ? (
          <p className="dac-countdown" role="timer">
            This tab will close automatically in <strong>{countdown}</strong>{" "}
            second{countdown !== 1 ? "s" : ""}.
          </p>
        ) : (
          <p className="dac-fallback-close" aria-hidden="true">
            Did not close? You may now close this browser tab.
          </p>
        )}
        <p className="visually-hidden" role="status">
          {countdown > 0
            ? ""
            : "Did not close? You may now close this browser tab."}
        </p>
        <p className="dac-fallback">
          Not working?{" "}
          <a href="https://app.4sightlabs.com" className="dac-link">
            Use OverWatch in your browser.
          </a>
        </p>
      </div>
    </main>
  );
}

export default DesktopAuthCompletedRouteComponent;
